import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, catchError } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class TasksAndMarketingService extends BehaviorSubject<any[]> {
  constructor(private _http: HttpClient) {
    super([])
  }
  getMarketingView(): Observable<any[]> {
    return this._http.get<any[]>(`/api/Marketing/GetMarketingNoOrderView`)
  }
  /*  getMarketingView(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Marketing/GetMarketingView`, r)
      .pipe(catchError(this.handleError))
  } */
  getMarketingItem(r: any): Observable<any> {
    return this._http
      .post<any>(`/api/Marketing/GetMarketingItem`, r)
      .pipe(catchError(this.handleError))
  }
  getTasksView(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Tasks/GetTasksView`, r)
      .pipe(catchError(this.handleError))
  }
  getTaskById(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Tasks/GetTaskById`, r)
      .pipe(catchError(this.handleError))
  }
  getMasterTasksView(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Tasks/GetMasterTaskView`, r)
      .pipe(catchError(this.handleError))
  }
  getMasterTaskById(r: any): Observable<any> {
    return this._http
      .post<any>(`/api/Tasks/GetMasterTaskById`, r)
      .pipe(catchError(this.handleError))
  }
  submitMarketingUpdate(r: any): Observable<string> {
    return this._http
      .post(`/api/Marketing/SubmitMarketingUpdate`, r, { responseType: 'text' })
      .pipe(catchError(this.handleError))
  }
  submitTaskUpdate(r: any): Observable<string> {
    return this._http
      .post(`/api/Tasks/SubmitTaskUpdate`, r, { responseType: 'text' })
      .pipe(catchError(this.handleError))
  }

  private handleError(error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
}
